class InternetGloboplayController {
	/** @param {string} mainClassname */
	constructor(mainClassname) {
		this.mainClassname = mainClassname;
		this.carrousel = new CardsCarrousel('internet-globoplay-carrousel');
		this.dotsContainerElement = document.getElementById(
			'internet-globoplay-dots'
		);

		this.autoSkipDeyay = 7000;

		this.renderDots();
		this.deployListeners();
		this.setDotActiveByIndex(0);
		this.deployAutoSkip({autoSkipDelay: this.autoSkipDeyay + 'ms'});
	}

	renderDots() {
		const {dotsAmount} = this.carrousel.properties;
		this.dotsContainerElement.innerHTML = '';

		for (let dotIndex = 0; dotIndex < dotsAmount; dotIndex++) {
			const dotButtonElement = document.createElement('button');
			dotButtonElement.setAttribute('aria-label', 'Mudança de Card')


			dotButtonElement.className = this.concatClasses(
				'dots-container',
				'childs'
			);

			dotButtonElement.addEventListener('click', () => {
				this.carrousel.setCurrentPositionByIndex(dotIndex);
			});

			this.dotsContainerElement.appendChild(dotButtonElement);
		}
	}

	deployListeners() {
		this.carrousel.on('resize', (props) => {
			this.renderDots();
			this.setDotActiveByIndex(props.currentDotIndex);
		});
		this.carrousel.on('scroll', (props) => {
			this.setDotActiveByIndex(props.currentDotIndex);
			this.deployAutoSkip({autoSkipDelay: this.autoSkipDeyay + 'ms'});
		});
		this.carrousel.on('changecards', (props) => {
			this.setDotActiveByIndex(props.currentDotIndex);
		});
	}

	setDotActiveByIndex(index) {
		this.childForEach((child, i) => {
			child.classList[index == i ? 'add' : 'remove'](
				this.concatClasses('dots-container', 'childs', 'active')
			);
		});
	}

	/** @param {{autoSkipDelay:string}} props */
	deployAutoSkip(props) {
		this.childForEach((child) => {
			child.style.animationDuration = props.autoSkipDelay;
		});

		clearTimeout(this.autoskipDebounce);
		this.autoskipDebounce = setTimeout(
			() => this.carrousel.next(),
			this.autoSkipDeyay
		);
	}

	/** @param {(children:Element, index:string) => void} callback */
	childForEach(callback) {
		[...this.dotsContainerElement.children].forEach(callback);
	}

	/** @param {...string} classes  */
	concatClasses(...classes) {
		return [this.mainClassname, ...classes].join('__');
	}
}

try {
	new InternetGloboplayController('internet-globoplay');
} catch (error) {
	console.log('erro ao instanciar carrousel');
}
